<div [ngStyle]="divStyle$ | async"
	[ngClass]="(displayedItems?.length$ | async) > 0 && !transparent ? 'calao-virtual-scroll-wrapper': ''">
	<cdk-virtual-scroll-viewport #viewportId [itemSize]="itemSize" [style.height]="maxHeight" [orientation]="orientation"
		[minBufferPx]="minBufferPx" [maxBufferPx]="maxBufferPx" [ngClass]="orientation">
		<ion-list [class]="orientation === 'horizontal' ? 'horizontal-list virtual-scroll-list' : 'virtual-scroll-list'">
			<ng-container *cdkVirtualFor="let item of displayedItems?.changes$; template: templateRef;"></ng-container>
		</ion-list>
	</cdk-virtual-scroll-viewport>
</div>